import type { SerializedHardware } from '@enmon/commons/lib/tools';
import type { AxiosError } from 'axios';
import { useServices } from 'containers/services';
import type { CreateHardwareArg } from 'lib/services';
import { useMutation, type UseMutationResult } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import type { StrapiApiErrorResponse } from 'utils/isStrapiApiErrorResponse';
import { notifyError, notifySuccess } from 'utils/notifications';
import { MUTATION_KEYS } from 'utils/queryKeys';

export const useCreateHardware = (
  onSuccess: (data: SerializedHardware) => void,
): UseMutationResult<SerializedHardware, unknown, CreateHardwareArg> => {
  const { hardwaresApiClient } = useServices();

  return useMutation((arg: CreateHardwareArg) => hardwaresApiClient.create(arg), {
    mutationKey: MUTATION_KEYS.hardwares.create(),
    onError: (error: AxiosError<StrapiApiErrorResponse>) => {
      notifyError(error, {
        message:
          error.response?.data.error.name === 'ValidationError'
            ? `Error creating hardware: ${getErrorMessage(error)}`
            : 'There was an error while creating hardware',
        description: error.message,
      });
    },
    onSuccess: data => {
      notifySuccess({
        message: `Hardware created`,
      });
      onSuccess(data);
    },
  });
};
